import { useState } from "react";
import { Check, Copy } from "@phosphor-icons/react";
import { toast } from "sonner";

export const LogoMark = ({ size = 28, tile = "#0E1729", fg = "#F4F6F8", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="15" fill={tile} />
    <path d="M32 13 L51 30 V47 a4 4 0 0 1 -4 4 H17 a4 4 0 0 1 -4 -4 V30 Z" fill={fg} />
    <circle cx="32" cy="34.5" r="5.2" fill={tile} />
    <path d="M29.6 36.5 L28 45.5 H36 L34.4 36.5 Z" fill={tile} />
  </svg>
);

export const Logo = ({ dark = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2 font-display tracking-tight ${className}`} data-testid="brand-logo">
    <LogoMark size={30} tile={dark ? "#F4F6F8" : "#0E1729"} fg={dark ? "#0E1729" : "#F4F6F8"} />
    <span className={`text-lg ${dark ? "text-white" : "text-[#0E1729]"}`}><b className="font-bold">hostkey</b><span className="font-light">.online</span></span>
  </span>
);

export function CopyButton({ value, label = "Copy", className = "", testId, done = "Copied" }) {
  const [ok, setOk] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      const t = document.createElement("textarea");
      t.value = value;
      document.body.appendChild(t);
      t.select();
      document.execCommand("copy");
      t.remove();
    }
    setOk(true);
    toast.success(done);
    setTimeout(() => setOk(false), 1600);
  };
  return (
    <button type="button" onClick={copy} data-testid={testId} className={`inline-flex items-center gap-1.5 transition-colors duration-200 ${className}`}>
      {ok ? <Check size={16} weight="bold" /> : <Copy size={16} />} {ok ? done : label}
    </button>
  );
}

export function PhoneFrame({ children }) {
  return (
    <div className="mx-auto w-[340px] rounded-[2.6rem] bg-[#151312] p-3 shadow-[0_30px_80px_-30px_rgba(21,19,18,.55)]" data-testid="phone-frame">
      <div className="relative h-[680px] overflow-hidden rounded-[2rem] bg-white">
        <div className="absolute left-1/2 top-2 z-30 h-5 w-24 -translate-x-1/2 rounded-full bg-[#151312]" />
        <div className="h-full overflow-y-auto no-scrollbar">{children}</div>
      </div>
    </div>
  );
}

export const StatusPill = ({ meta, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${meta.cls}`}>{meta.label}</span>
);
